enum FrontendEnabledMenus {
	None = 0,
	NewPermits = 1,
	Permits = NewPermits << 1,
	Payments = Permits << 1,
	Documents = Payments << 1,
	Drivers = Documents << 1,
	Residencies = Drivers << 1,
	Vehicles = Residencies << 1,
	Invoices = Vehicles << 1,
	Settings = Invoices << 1,
	All = 0xffffffff
}

export default FrontendEnabledMenus;
